import { toRaw } from 'vue'
import AuthMixin from '@/components/mixins/auth-mixin'
import EventBus from '@/components/mixins/event-bus-mixin'
import CreateTemplateSetProperties from './create-template-set-menu/create-template-set-menu-tmpl'
import TemplateMixin from '@/components/mixins/template-mixin'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import Draggable from 'vuedraggable'
import _ from 'lodash'
import { hasPermissionToCreateStyle } from '@/utils/templates-page-accessibility.js'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'
import { useCognitoAuthStore } from '@base-shared/stores/cognito-auth'

const CLIPBOARD_COPY_PASTE_TEXTAREA_ID = 'clipboardCopyPasteTemplateContent'

export default {
  name: 'create-template-set',
  inject: [
    '$currentUser',
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  components: {
    templateSetProperties: CreateTemplateSetProperties,
    Draggable
  },
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {},
  computed: {
    sortDraggableOptions () {
      return { animation: 250, group: 'description', disabled: false, ghostClass: 'sortable-ghost' }
    },
    defaultTemplateSet () {
      return this.templateSets.find((template) => template.groupId === 'default' && !template.userDefined)
    },
    filteredTemplateSets () {
      const filteredSet = this.templateSets.filter((template) => template.name.toLowerCase().includes(this.searchValue.toLowerCase())
      )

      return filteredSet.sort((a, b) => a.name.localeCompare(b.name, this.$dataStore.getLanguage().code, { sensitivity: 'base' })
      )
    },
    isCreateStyleEnabled () {
      return hasPermissionToCreateStyle(this.$currentUser)
    }
  },
  data () {
    return {
      error: '',
      isUserCreateLocked: this.$currentUser.getRights().userCreateLock,
      enableChangeTemplateSetSettings: this.$currentUser.getRights().userCreate.editTemplateSetStyle,
      enableCreateNewProject: this.$currentUser.getRights().userCreate.createNewProject,
      enableEditProject: this.$currentUser.getRights().userCreate.editProject,
      enableEditTemplateSet: false,
      isCovidButtonVisible: false,
      enableNewTemplateSetButton: true,
      projectOrientation: 'horizontal',
      templateSets: [],
      templateSetsSelected: '',
      template: {},
      templateMenuType: null,
      templateSetHover: null,
      prevTemplatesBeforeRemoveItem: null,
      inlineEditName: {
        isInputVisible: false,
        templateId: null,
        previousVal: null,
        requesting: false
      },
      ledTags: [],
      tagsSummary: [],
      hoveredTemplate: null,
      hoveredTemplateSet: null,
      copyPasteEventLog: {
        ref: null,
        copy: false,
        paste: false,
        apiRequest: null
      },
      templatesBeforeSort: null,
      templateCardTargetBeforeSortPosition: {},
      templateCardTargetAfterSortPosition: {},
      isCtrlKeyPressed: false,
      isShiftKeyPressed: false,
      templateDragToStyleSetIdOnOver: null,
      isLastPositionOfGrabbedTemplateInsideSortableContent: true,
      isTemplateGrabbing: false,
      isHorizontalAndVerticalIconVisible: false,
      updatedRightOptionsBeforeGetTemplates: null,
      searchValue: '',
      noStylePackAccess: false
    }
  },
  mixins: [AuthMixin, TemplateMixin, UnsavedDataMixin, OnEnterMixin],
  methods: {
    setDefaultData () {
      const authParams = {
        callback: () => {
          this.setEditTemplateSetContract()
          this.projectOrientation = this.$dataStore.getMediaOrientation()// Keep previous media orientation selection
          this.getTemplateSets(true, true)
          this.getTagsSummary()
          this.handleHorizontalAndVerticalIconVisibility()
        }
      }
      useMixpanel().track('Create - Template')
      this.isAuthenticated(authParams)
    },
    handleHorizontalAndVerticalIconVisibility () {
      let isHorizontalAndVerticalIconVisible = true

      if (this.$currentUser.hasGroupUserLimited()) {
        isHorizontalAndVerticalIconVisible = false
      }

      this.isHorizontalAndVerticalIconVisible = isHorizontalAndVerticalIconVisible
    },
    setCtrlKeyPressed () {
      $(document).on('keydown', (e) => {
        if (e.ctrlKey || (e.key === 17 || e.which === 17)) {
          this.isCtrlKeyPressed = true
          this.setContentCursor({ copy: true })
        }
      })

      $(document).on('keyup', (e) => {
        this.isCtrlKeyPressed = false
        this.unsetContentCursor({ copy: true })
      })
    },
    setShiftKeyPressed () {
      $(document).on('keydown', (e) => {
        if (e.shiftKey || (e.key === 16 || e.which === 16)) {
          this.isShiftKeyPressed = true
          this.setContentCursor({ copy: true })
        }
      })

      $(document).on('keyup', (e) => {
        this.isShiftKeyPressed = false
        this.unsetContentCursor({ copy: true })
      })
    },
    setContentCursor (params) {
      if (params.copy) {
        $('.content-template-item').each((i, el) => { $(el).addClass('copy-cursor') })
      } else if (params.move) {
        $('.content-template-item').each((i, el) => { $(el).addClass('move-cursor') })
      }
    },
    unsetContentCursor (params) {
      if (params.copy) {
        $('.content-template-item').each((i, el) => { $(el).removeClass('copy-cursor') })
      } else if (params.move) {
        $('.content-template-item').each((i, el) => { $(el).removeClass('move-cursor') })
      }
    },
    handleCardHoverStyle (templateId, action) {
      const templateListContainerEl = $('#templateListContainer')
      const targetTemplateCardEl = $(`.template-item-${templateId}`)

      templateListContainerEl.find('.template-item').each((indx, element) => {
        $(element).removeClass('card-hover')
        $(element).find('.template-preview-fixed').removeClass('card-hover')
      })

      targetTemplateCardEl.addClass('card-hover')
      targetTemplateCardEl.find('.template-preview-fixed').addClass('card-hover')
    },
    handleHideTemplateInSet (item, params) {
      if (!params) params = { confirm: true }

      const apiRequest = () => {
        const template = this.$utils.clone(this.template)
        this.prevTemplatesBeforeRemoveItem = this.$utils.clone(template.templates)

        const newTemplates = template.templates.filter((temp) => { return temp.templateId !== item.templateId })
        template.templates = newTemplates
        this.template = this.filterTemplate(template)

        this.$api.put(`${CONFIG.API_BASE_URL}/template/${item.templateSetId}/${item.templateId}`, { hidden: true })
          .then(response => {
            this.prevTemplatesBeforeRemoveItem = null
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }

      if (params.confirm) {
        EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
          type: 'warning',
          title: this.$t('confirm.deleteTemplate'),
          descriptionI18n: {
            key: 'templates.removeTemplateConfirmation',
            params: { styleName: this.template.name }
          },
          confirmButtonText: this.$t('buttons.deleteTemplate'),
          confirmButtonIcon: 'flowbite:trash-bin-solid',
          callbacks: {
            eventOKButtonClick: () => {
              apiRequest()
            }
          }
        })
      } else {
        apiRequest()
      }
    },
    handleCopyTemplateInSet (item, callback) {
      const requestData = { projectId: item.projectId ? item.projectId : item.templateId }

      if (!requestData.projectId && item.resourceId) requestData.projectId = item.resourceId

      this.$utils.mainLoader(true)
      const apiRequest = () => {
        this.$api.post(`${CONFIG.API_BASE_URL}/template/${item.templateSetId}`, requestData)
          .then(response => {
            if (callback) {
              callback()
            } else {
              this.getTemplateSets(true, true)
            }
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    handleTemplateCardActionsSetVisibility (params) {
      if (!params) params = {}

      this.setEditTemplateSetContract()

      if (params.defaultStyle) {
        this.enableEditTemplateSet = false
      }
    },
    setEditTemplateSetContract () {
      this.enableEditTemplateSet = this.$currentUser.hasGroupUserAdmin()
    },
    /**
     * Get list of template set in the API
     * @param {Boolean} clearCurrentTemplateData
     */
    getTemplateSets (clearCurrentTemplateData, checkSelectedTemplateSetIfExistInList, params) {
      if (!params) { params = {} }

      const apiRequest = () => {
        this.$utils.mainLoader(true)
        this.error = ''
        const params = {
          use_qsa: 1
        }

        this.$api.get(`${CONFIG.API_BASE_URL}/template`, { params })
          .then(response => {
            const responseData = response.data

            if (this.$currentUser.getUserTags().length) {
              // If user has a user assigned tag, we dont allow creation of new style pack
              this.enableNewTemplateSetButton = false

              // If user has assigned user tags AND no other style packs are available for user's account,
              // then show a message that user has no access to templates page
              if (responseData.length === 1 && responseData[0].groupId === 'default') {
                this.$utils.mainLoader(false)
                this.noStylePackAccess = true
                return
              }
            }

            // If no template set is selected then set a default value based from reponse
            if (this.templateSetsSelected === '') {
              let defaultTemplateSetsSelected = ''

              if (responseData.length === 1) {
                defaultTemplateSetsSelected = responseData[0]
                this.templateMenuType = 'newTemplateSet'
              } else if (responseData.length >= 1) {
                defaultTemplateSetsSelected = responseData[1]
              }

              this.templateSetsSelected = defaultTemplateSetsSelected
            }

            // User Rights contract level to hide the NEW templateSet button
            if (!this.$currentUser.getRights().userCreate.createTemplateSetStyle && responseData.length === 1) {
              this.templateMenuType = null
              this.enableNewTemplateSetButton = false
            }

            // Check if the previous selected templateSet(from localstorage) exist in the current list
            if ((typeof checkSelectedTemplateSetIfExistInList === 'boolean') && (checkSelectedTemplateSetIfExistInList)) {
              if ((this.getTemplateSetSelectionFromLocalStorage() !== null) && (this.getTemplateSetSelectionFromLocalStorage().length > 0)) {
                const selectedTemplateSetFromLocStorage = this.getTemplateSetSelectionFromLocalStorage()[0]

                for (const indx in responseData) {
                  if (responseData[indx].templateSetId === selectedTemplateSetFromLocStorage.templateSetId) {
                    this.templateSetsSelected = selectedTemplateSetFromLocStorage
                    this.templateSets = this.filterTemplateSets(responseData)
                    break
                  }
                }
              }
            }

            this.templateSets = this.filterTemplateSets(responseData)

            if (params && params.newCloneTemplateSets) {
              const findTemplateSet = this.templateSets.find((item) => { return item.templateSetId === params.newCloneTemplateSets.templateSetId })
              if (findTemplateSet) {
                this.setTemplateSetSelectionToLocalStorage([findTemplateSet])
                this.templateSetsSelected = findTemplateSet
              }
            }

            // Get Templates
            this.getTemplates(this.templateSetsSelected.templateSetId, clearCurrentTemplateData)
          })
          .catch((error) => {
            this.error = error.message
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    /**
     * Get template using templateSetId
     * @param {String} templateSetId
     * @param {Boolean} clearCurrentTemplateData - reset current template data before fetching
     */
    getTemplates (templateSetId, clearCurrentTemplateData, additionalParams, actionType) {
      this.handleTemplateCardActionsSetVisibility({ defaultStyle: templateSetId === 'default' })

      let params = {
        dir: this.$dataStore.getMediaOrientation(),
        max: 30,
        width: 1280,
        locale: this.$t?.locale?.value ?? 'en',
        use_qsa: 1
      }

      // Merge additional request params
      if (typeof (additionalParams) === 'object') {
        params = { ...params, ...additionalParams }
      }

      if (typeof (clearCurrentTemplateData) === 'boolean' && clearCurrentTemplateData) {
        this.template = {}
      }

      this.$utils.mainLoader(true)
      const apiRequest = () => {
        this.error = ''

        this.$api.get(`${CONFIG.API_BASE_URL}/template/${templateSetId}`, { params })
          .then(response => {
            const newTemplateResponseData = response.data
            let currentTemplate = this.$utils.clone(this.template)

            // Set template options
            if (this.updatedRightOptionsBeforeGetTemplates) {
              newTemplateResponseData.options = this.updatedRightOptionsBeforeGetTemplates.options
              newTemplateResponseData.name = this.updatedRightOptionsBeforeGetTemplates.name
              newTemplateResponseData.tags = this.updatedRightOptionsBeforeGetTemplates.tags ? this.updatedRightOptionsBeforeGetTemplates.tags : []
              newTemplateResponseData._newUploadedFont = this.updatedRightOptionsBeforeGetTemplates._newUploadedFont

              this.updatedRightOptionsBeforeGetTemplates = null
            }

            if (typeof (actionType) === 'string' && actionType === 'getMoreItems') {
              currentTemplate.templates.push(...newTemplateResponseData.templates)

              currentTemplate.moreItems = false
              currentTemplate.exclusiveStartTemplateId = false
              currentTemplate.exclusiveStartGroupId = null

              if (newTemplateResponseData.moreItems && newTemplateResponseData.exclusiveStartTemplateId) {
                currentTemplate.moreItems = true
                currentTemplate.exclusiveStartTemplateId = newTemplateResponseData.exclusiveStartTemplateId ? newTemplateResponseData.exclusiveStartTemplateId : null
                currentTemplate.exclusiveStartGroupId = newTemplateResponseData.exclusiveStartGroupId ? newTemplateResponseData.exclusiveStartGroupId : null
              }

              this.template = this.filterTemplate(currentTemplate)
            } else {
              currentTemplate = newTemplateResponseData
              this.template = this.filterTemplate(currentTemplate)
            }

            this.$nextTick(_ => { this.watchTemplateCardGrabbing() })
            this.$utils.mainLoader(false)
          })
          .catch((error) => {
            this.error = error.message
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    /**
     * Handle Template Sets Tag onClick
     * @param {Object} templateSet - selected template set
     */
    handleTemplateSetTagClick (templateSet, action, checkUnsaveData) {
      const templateSetOnClickAction = () => {
        this.inlineEditName = {
          isInputVisible: false,
          templateId: null,
          previousVal: null,
          requesting: false
        }

        if (!templateSet._edit.isSelected) {
          this.getTemplates(templateSet.templateSetId, true)
        }

        this.templateSetsSelected = templateSet
        this.templateSets = this.filterTemplateSets(this.templateSets)

        // User Rights contracts layer
        if (!this.enableChangeTemplateSetSettings) {
          return
        }

        // Adjust Template Set Menu
        if ((templateSet.groupId === 'default') && (!templateSet.userDefined)) {
          this.templateMenuType = 'newTemplateSet'
        } else {
          this.templateMenuType = 'editTemplateSet'
        }

        if (action === 'edit') {
          // Save to local storage
          this.setTemplateSetSelectionToLocalStorage([templateSet])
        }
      }

      if (checkUnsaveData) {
        this.checkUnsavedData({
          nextAction: () => {
            templateSetOnClickAction()
          }
        })
      } else {
        templateSetOnClickAction()
      }
    },
    /**
     * Filter template sets Object
     * @param {Object} filterTemplateSetsSrc
     */
    filterTemplateSets (filterTemplateSetsSrc) {
      const filterTemplateSets = this.$utils.clone(filterTemplateSetsSrc)

      for (const indx in filterTemplateSets) {
        const templateSet = filterTemplateSets[indx]

        // Add _edit property
        if (!templateSet._edit) {
          templateSet._edit = {
            isSelected: false
          }
        }

        // Set isSelected value
        if (this.templateSetsSelected.templateSetId === templateSet.templateSetId) {
          templateSet._edit.isSelected = true
        } else {
          templateSet._edit.isSelected = false
        }
      }

      return filterTemplateSets
    },
    filterTemplate (templateSrc = {}) {
      const template = this.$utils.clone(templateSrc)

      if (template.templates) {
        const templates = template.templates

        for (const indx in templates) {
          const temp = templates[indx]

          if (!temp._edit) {
            temp._edit = {
              uid: temp.templateId
            }
          }

          temp._edit.modifiedFile = false
          const file = {
            templateSetId: temp.templateSetId,
            templateId: temp.templateId,
            type: 'template'
          }
          if (temp.edit && (temp.edit.userId && temp.edit.modifiedAt)) {
            file.modifiedAt = temp.edit.modifiedAt
            file.userId = temp.edit.userId
            temp._edit.modifiedFile = this.$dataStore.isModifiedFile({ file })
          } else if (temp.modifiedAt && temp.userId) {
            file.modifiedAt = temp.modifiedAt
            file.userId = temp.userId
            temp._edit.modifiedFile = this.$dataStore.isModifiedFile({ file })
          }

          if (!temp.order) {
            const topSiblingDetails = (templates[indx - 1]) ? templates[indx - 1] : false
            const bottomSiblingDetails = (templates[indx + 1]) ? templates[indx + 1] : false
            const topSiblingOrder = topSiblingDetails ? topSiblingDetails.order : false
            const bottomSiblingOrder = bottomSiblingDetails ? bottomSiblingDetails.order : false
            temp.order = this.$utils.calculateSortOrderValue({ topSiblingOrder, bottomSiblingOrder, previousOrderVal: 0 })
          }

          // Set card size className for card dimension in css
          if (temp.size && temp.size.toString() === '2') {
            temp._edit.cardSizeClass = 'size-medium'
          } else if (temp.size && temp.size.toString() === '3') {
            temp._edit.cardSizeClass = 'size-large'
          } else {
            temp._edit.cardSizeClass = 'size-default'
          }
        }
      }

      return template
    },
    handleDeleteTemplateSet (templateSet) {
      EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
        type: 'warning',
        title: this.$t('confirm.deleteStyle'),
        descriptionI18n: {
          key: 'templates.deleteStyleConfirmation',
          params: { styleName: templateSet.name }
        },
        alert: {
          message: this.$t('templates.deleteStyleWarning')
        },
        confirmButtonText: this.$t('buttons.deleteStyle'),
        confirmButtonIcon: 'flowbite:trash-bin-solid',
        callbacks: {
          eventOKButtonClick: () => {
            const apiRequest = () => {
              this.$utils.mainLoader(true)
              this.error = ''
              this.$api.delete(`${CONFIG.API_BASE_URL}/template/${templateSet.templateSetId}`)
                .then(response => {
                  // Remove this template set in localstorage
                  if (templateSet._edit.isSelected) {
                    this.removeTemplateSetSelectionFromLocalStorage()
                  }

                  this.templateSetsSelected = ''
                  this.getTemplateSets(true, true)
                })
                .catch((error) => {
                  this.error = error.message
                  this.$utils.mainLoader(false)
                  this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
                })
            }
            apiRequest()
          }
        }
      })
    },
    handleTemplateSetCopy (templateSet) {
      const apiRequest = () => {
        this.$utils.mainLoader(true)
        this.error = ''

        const requestData = {
          templateSetId: templateSet.templateSetId,
          name: templateSet.name
        }

        this.$api.post(`${CONFIG.API_BASE_URL}/template`, requestData)
          .then(response => {
            this.templateSetsSelected = response.data
            this.getTemplateSets(true, false, { newCloneTemplateSets: response.data })
          })
          .catch((error) => {
            this.error = error.message
            this.$utils.mainLoader(false)
            this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
          })
      }
      apiRequest()
    },
    /**
     * Handle submitting of data into the API once schedule list tag is edited
     */
    handleTemplateSetTagEdited () {
      const templateSet = this.$utils.clone(this.templateSetsSelected)
      const inputValue = this.templateSetFilter.editNameValue

      if ((templateSet.name !== inputValue) && (inputValue !== '')) {
        templateSet.name = inputValue

        // Update current Template Sets
        this.templateSets = this.$utils.updateItemFromList(this.templateSets, templateSet, 'templateSetId')
        this.templateSetsSelected = templateSet
        this.templateSets = this.filterTemplateSets(this.templateSets)

        delete templateSet.options

        const apiRequest = () => {
          this.$utils.mainLoader(true)
          this.$api.put(`${CONFIG.API_BASE_URL}/template/${templateSet.templateSetId}`, templateSet)
            .then(response => {
              this.getTemplateSets(false)
            })
            .catch((error) => {
              this.$utils.mainLoader(false)
              this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
            })
        }
        apiRequest()
      }

      this.templateSetFilter.isEditInputVisible = false
    },
    /**
     * A hook function once the template sets sub-component will change or dispatch an event
     * @param {Object} event - event data
     */
    handleTemplatePropertiesChange (event) {
      if (event.action === 'NEW_TEMPLATE_SET_CREATED') {
        useMixpanel().track('Create template set')
        const newTemplateSet = event.payload.data
        newTemplateSet._edit = {
          isSelected: false
        }

        this.templateSetsSelected = newTemplateSet
        this.handleTemplateSetTagClick(newTemplateSet, 'edit', true)
        this.templateMenuType = null
        this.getTemplateSets(true)
      }

      if (event.action === 'TEMPLATE_SET_UPDATED') {
        this.templateMenuType = null
        this.getTemplateSets(true)
      }

      if (event.action === 'TEMPLATE_SET_PREVIEW') {
        const templateSetData = event.payload.data.template
        const eventAction = event.payload.data.eventAction

        if (eventAction === 'FONT_UPLOAD_DONE') {
          /**
           * Keep the updated data from right options and refetch templates to detect new fonts inside templates.
           * Once request is done, it will use the updated right options.
           * This will also keep the selected template set without checking unsave changes to avoid showing of warning dialog after upload.
           */
          this.$utils.mainLoader(true)
          templateSetData._newUploadedFont = true
          this.updatedRightOptionsBeforeGetTemplates = templateSetData

          const clickAction = templateSetData.userDefined ? 'create' : 'edit'
          const templateSetsSelected = this.$utils.clone(this.templateSetsSelected)
          if (!templateSetsSelected._edit) templateSetsSelected._edit = {}
          templateSetsSelected._edit.isSelected = false
          this.handleTemplateSetTagClick(templateSetsSelected, clickAction, false)
        } else {
          this.sendPostMessageToEachTemplateSet(templateSetData.options)
        }
      }
    },
    handleSVGOnLoad () {
      this.sendPostMessageToEachTemplateSet(this.template.options)
    },
    sendPostMessageToEachTemplateSet (setOptions) {
      const postMessageDataModel = {
        setOptions: toRaw(setOptions),
        projectOptions: {
          dir: toRaw(this.projectOrientation)
        }
      }
      postMessageDataModel.setOptions.logo.href = setOptions.logo.preview.url

      for (const template of this.template.templates) {
        $(`#template-${template.templateId}`)[0].contentWindow.postMessage(postMessageDataModel, '*')
      }
    },
    handleTemplateCardClick (item) {
      this.checkUnsavedData({
        nextAction: () => {
          useMixpanel().track('Templates clicks')

          let pageRedirectAfterCreateProjectPath = this.$route.fullPath
          if ((this.templateSetsSelected.groupId === 'default') && (!this.templateSetsSelected.userDefined)) { // For new template set, should redirect to media files page
            pageRedirectAfterCreateProjectPath = '/media'
            this.$dataStore.setStore({ prevPage: 'createProject' })
          }

          if (item.edit) {
            if (!this.enableEditProject) return
            this.$dataStore.setStore({ pageRedirectAfterCreateProject: pageRedirectAfterCreateProjectPath, prevPage: 'editProject' })
            this.$router.push(`/project-edit/${item.edit.resourceId}/edit-frame`, () => {})
          } else {
            if (!this.enableCreateNewProject) return
            this.$dataStore.setStore({ pageRedirectAfterCreateProject: pageRedirectAfterCreateProjectPath, prevPage: 'editProject' })
            this.$router.push(`/template/${this.template.templateSetId}/${item.templateId}`, () => {})
          }
        }
      })
    },
    handleTemplateCardCopyClick (item) {
      this.checkUnsavedData({
        nextAction: () => {
          this.$dataStore.setStore({ pageRedirectAfterCreateProject: this.$route.fullPath })
          this.$router.push(`/template/${this.template.templateSetId}/${item.templateId}`, () => {})
        }
      })
    },
    handleProjectOrientationClick (orientation) {
      this.projectOrientation = orientation
      this.$dataStore.setMediaOrientation(orientation)

      this.getTemplateSets(true)
    },
    handlePageContentOptionClick (pageContent) {
      this.$router.push(`/media-and-template/${pageContent}`, () => {})
    },
    handleStyleActionBtnClick () {
      // User Rights contract layer
      if (!this.enableChangeTemplateSetSettings) {
        return false
      }

      // Check unsaved data first before changing right controls
      this.checkUnsavedData({
        nextAction: () => {
          this.templateMenuType = null
          this.removeTemplateSetSelectionFromLocalStorage()
        }
      })
    },
    handleTemplateCardCoverClickCapture (item, $event) {
      if (this.isTemplateGrabbing) return

      if ($($event.target).hasClass('preview-content-cover')) {
        this.handleTemplateCardClick(item)
      }

      if ($($event.target).hasClass('copy')) {
        if (!this.enableCreateNewProject) {
          return
        }

        this.handleTemplateCardCopyClick(item)
      }
    },
    handleInlineEditNameClick (event, item, currentMediaItemPosition) {
      // User Rights contract level
      if (!this.enableEditTemplateSet) return
      if (this.templateSetsSelected && !this.templateSetsSelected.userDefined) return
      if (item.disabled) return

      const isMediaSelected = true

      // If selected, then enable the edit media name field
      if (isMediaSelected) {
        const inlineEditName = this.$utils.clone(this.inlineEditName)
        inlineEditName.isInputVisible = true
        inlineEditName.templateId = item.templateId

        this.inlineEditName = inlineEditName
        this.$nextTick(_ => {
          this.$refs[`${item.templateId}-editName`][0].$refs.input.focus()
          this.inlineEditName.previousVal = item.name
        })
      }

      // If media is not selected, then set the media a selected
      if (!isMediaSelected) this.handleMediaCardClick(event, item, currentMediaItemPosition)
    },
    handleInlineEditNameInputConfirm (templateItem, event) {
      if (this.inlineEditName.previousVal === templateItem.name || this.inlineEditName.requesting) {
        this.inlineEditName.isInputVisible = false
        return
      }

      const requestData = {
        name: templateItem.name
      }

      const apiRequest = () => {
        const inlineEditName = this.$utils.clone(this.inlineEditName)
        inlineEditName.requesting = true
        this.inlineEditName = inlineEditName

        this.$utils.mainLoader(true)
        this.$api.put(`${CONFIG.API_BASE_URL}/template/${this.templateSetsSelected.templateSetId}/${templateItem.templateId}`, requestData)
          .then(response => {
            const inlineEditName = this.$utils.clone(this.inlineEditName)
            inlineEditName.isInputVisible = false
            inlineEditName.templateId = null
            inlineEditName.previousVal = templateItem.name
            inlineEditName.requesting = false
            this.inlineEditName = inlineEditName

            if (response.data.newTemplateId) {
              this.getTemplateSets(true, true)
            } else {
              this.$utils.mainLoader(false)
            }
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })

            const inlineEditName = this.$utils.clone(this.inlineEditName)
            inlineEditName.requesting = false
            this.inlineEditName = inlineEditName
          })
      }
      apiRequest()
    },
    getTagsSummary (params) {
      if (!params) params = {}
      this.$api.get(`${CONFIG.API_BASE_URL}/group/tags/?type=ledTags,resourceTags,playerTags&ext=1`)
        .then(response => {
          // Set Led Tags
          const responseData = response.data
          this.ledTags = (responseData.ledTags && responseData.ledTags.length) ? responseData.ledTags : []

          // Resource and Player tags
          const resourceTags = responseData.resourceTags ? responseData.resourceTags : []
          const filteredPlayerTags = responseData.playerTags ? responseData.playerTags.filter((t) => { return resourceTags.indexOf(t) < 1 }) : []
          this.tagsSummary = this.$utils.filterTagOptionsForUI({ tags: resourceTags.concat(filteredPlayerTags) })
        })
        .catch((error) => {
          this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { this.getTagsSummary() } })
        })
    },
    handleSVGMessage (event) {
      // Make sure event.origin is from the app to prevent accepting message out of nowhere and event.data is an object
      const sessionStage = useCognitoAuthStore().sessionStage ?? CONFIG.GLOBAL_STAGE;
      const apiOrigin = (new URL(this.$utils.getStageAPIUrl(sessionStage))).origin
      if ((event.origin !== apiOrigin) || (!_.isPlainObject(event.data))) return

      if (event.data && event.data.loaded && event.data.uri) $(`.project-template[src="${event.data.uri}"]`).addClass('iframe-loaded')
    },
    postMessageToSVG (params) {
      const selectedSchedulePreviewEl = $(`#${params.projectTemplateId}`)

      if (selectedSchedulePreviewEl.length) {
        const mediaOrientation = this.$dataStore.getMediaOrientation() ? this.$dataStore.getMediaOrientation() : 'horizontal'
        const msg = {
          projectOptions: { dir: mediaOrientation }
        }
        selectedSchedulePreviewEl[0].contentWindow.postMessage(msg, '*')
      }
    },
    addMessageListener () {
      if (!this.handleSVGMessageEventListenerFunction) {
        this.handleSVGMessageEventListenerFunction = this.handleSVGMessage.bind(this)
        window.addEventListener('message', this.handleSVGMessageEventListenerFunction)
      }
    },
    removeMessageListener () {
      if (this.handleSVGMessageEventListenerFunction) {
        window.removeEventListener('message', this.handleSVGMessageEventListenerFunction)
        this.handleSVGMessageEventListenerFunction = null
      }
    },
    handleClipboardCopyAndPaste (params) {
      if (!params) params = {}

      const templateCardHover = params.templateCardHover
      const templateSetHover = params.templateSetHover
      let contentEl = document.getElementById(CLIPBOARD_COPY_PASTE_TEXTAREA_ID)

      if (this.enableEditTemplateSet && !contentEl) {
        contentEl = document.createElement('textarea')
        contentEl.id = CLIPBOARD_COPY_PASTE_TEXTAREA_ID
        Object.assign(contentEl.style, { opacity: 0, position: 'fixed', height: '0px', width: '0px', left: 0, top: 0, zIndex: 1 })
        document.body.appendChild(contentEl)
        contentEl.focus()

        // Handle copy event
        contentEl.addEventListener('copy', (event) => {
          let clipboardData = null

          if (this.hoveredTemplate && !this.inlineEditName.isInputVisible) {
            clipboardData = JSON.stringify(this.hoveredTemplate, undefined, 2)
          } else if (this.hoveredTemplateSet) {
            clipboardData = JSON.stringify(this.hoveredTemplateSet, undefined, 2)
          }

          if (clipboardData) {
            contentEl.textContent = clipboardData
            event.clipboardData.setData('text/plain', clipboardData)
          }

          event.preventDefault()
        })

        // Handle paste Event
        contentEl.addEventListener('paste', (event) => {
          const text = (event.clipboardData || window.clipboardData).getData('text')

          if (!text || (text && !text.length)) return

          const clipboardData = JSON.parse(text)

          const extractedData = clipboardData?.item ?? clipboardData;

          if (extractedData?.led) {
            // An LED/videowall template is identified by the presence of the 'led' property.
            // Skip if the clipboard data contains an 'led' property as we do not allow copy from LED
            // to templates page for now
            return;
          }

          if (!extractedData.projectId) {
            if (extractedData.resourceId) {
              // Copied data is a resource
              extractedData.projectId = extractedData.resourceId;
            } else if (extractedData.templateId) {
              // Copied data is a template
              extractedData.projectId = extractedData.templateId;
            }
          }

          if (extractedData.projectId) {
            // Copy template to currently selected template set
            extractedData.templateSetId = this.templateSetsSelected?.templateSetId ?? '';
            this.handleCopyTemplateInSet(extractedData);
          } else if (extractedData.templateSetId) {
            // If no projectId then copied data is not a template.
            // And if there is a templateSetId, then it's a templateSet
            // Perform action to copy a template set
            this.handleTemplateSetCopy(extractedData);
          }

          event.preventDefault()
        })
      } else {
        // For template card hover
        if (contentEl && ((templateCardHover && !this.inlineEditName.isInputVisible) || templateSetHover)) {
          contentEl.focus()
          contentEl.select()
        }
      }
    },
    handleTemplateCardMouseOver (template) {
      this.hoveredTemplate = template
      this.hoveredTemplateSet = null

      this.handleCardHoverStyle(template.templateId, 'coverOnHover')

      // If Template grabbed for sorting, do not proceed
      if (this.isTemplateGrabbing) {
        return
      }

      this.handleClipboardCopyAndPaste({ templateCardHover: true })
    },
    handleTemplateCardMouseOut () {
      const templateListContainerEl = $('#templateListContainer')
      templateListContainerEl.find('.template-item').each((indx, element) => {
        $(element).removeClass('card-hover')
        $(element).find('.template-preview-fixed').removeClass('card-hover')
      })
    },
    handleTemplateSetMouseMoveEvents (type, templateSet) {
      if (type === 'mouseover') {
        this.hoveredTemplate = null
        this.hoveredTemplateSet = templateSet
        this.handleClipboardCopyAndPaste({ templateSetHover: true })
      }
    },
    handleTemplateSortClone () {
      /**
       * Sortable MAC style Idea
       * - onClone event adjust the selected card style to become invisible, actually DOM exist just to trigger sort event.
       *   Added a timeout so that cloned element can copy the original position of grabbed card before it will hide and change it's position.
       * - Get the next card position and insert(before) an empty card to replicate the original position of the grabbed card.
       * - Use handleTemplateCardMouseOver() to get the new position and show the vertical flag
       *   Note: newIndex value from vue draggable is inconsistent because of customized DOM in sorting
       */
      this.templateCardTargetBeforeSortPosition = null
      this.templateCardTargetAfterSortPosition = null
      setTimeout(() => {
        const templateListContainerEl = $('#templateListContainer')
        let currentIndex = null
        const grabbedCardEl = templateListContainerEl.find('.sortable-ghost')
        currentIndex = grabbedCardEl.index()

        if (currentIndex !== null) {
          this.templateCardTargetBeforeSortPosition = grabbedCardEl.offset()
        }
      }, 1)
    },
    handleTemplateSortStart () {
      this.isTemplateGrabbing = true
      EventBus.$emit('SORTING_START', { projectTemplatesPage: true })
      this.updateStyleDroppableEl({ show: true }) // Show droppable style set elements
      this.watchTemplateCardGrabbing()
      this.templatesBeforeSort = this.$utils.clone(this.template.templates)
      this.isLastPositionOfGrabbedTemplateInsideSortableContent = true
    },
    handleTemplateSortEnd (sortEvtVal) {
      EventBus.$emit('SORTING_END', { projectTemplatesPage: true })
      // Previous Data
      const templatesBeforeSort = this.$utils.clone(this.templatesBeforeSort)
      const previousIndexInList = sortEvtVal.oldIndex
      const previousOrderVal = templatesBeforeSort[previousIndexInList].order

      /**
       * - Remove grabbing flag with timeout to prevent onCardClick and dropped event conflict
       * - Hide all style droppable elements
       */
      setTimeout(() => { this.isTemplateGrabbing = false }, 1)
      this.updateStyleDroppableEl({ reset: true })
      this.unsetContentCursor({ copy: true })

      /**
       * Check if dropped into Style Sets using original path
       * Note: Some browsers not returning orignal path (like firefox) so get the last styleSetId from grabbing-mousemove. See mouseover event in watchTemplateCardGrabbing()
       */
      const origPathDropped = (sortEvtVal.originalEvent && sortEvtVal.originalEvent.path && sortEvtVal.originalEvent.path.length) ? sortEvtVal.originalEvent.path[0] : false
      let targetStyleId = null

      if (origPathDropped && $(origPathDropped).hasClass('style-set-droppable')) {
        const getStyleIdInClass = (origPathDropped.parentElement && origPathDropped.parentElement.className) ? origPathDropped.parentElement.className.toString().match(/(\bstyleId\S+\b)/ig) : []
        targetStyleId = getStyleIdInClass && getStyleIdInClass.length ? getStyleIdInClass[0].substr(7) : null
      } else {
        targetStyleId = this.templateDragToStyleSetIdOnOver
      }

      // Process Copy/Move template into Style Sets and do not proceed to sorting
      if (targetStyleId) {
        const updatedTemplate = this.$utils.clone(templatesBeforeSort[previousIndexInList])
        updatedTemplate.templateSetId = targetStyleId

        if (this.template.templateSetId === targetStyleId) {
          if (this.isShiftKeyPressed) {
            // Do nothing
          } else {
            this.handleCopyTemplateInSet(updatedTemplate) // Copy to its own set
          }
        } else {
          if (this.isShiftKeyPressed) { // Move
            this.handleCopyTemplateInSet(updatedTemplate, () => {
              this.handleHideTemplateInSet(templatesBeforeSort[previousIndexInList], { confirm: false })
              this.$utils.$mainLoader(false)
            })
          } else { // Copy
            this.handleCopyTemplateInSet(updatedTemplate, () => { this.$utils.mainLoader(false) })
          }
        }

        this.template.templates = this.filterTemplate(templatesBeforeSort)

        return
      }

      // Do not proceed sorting if dropped outside sortable content
      if (!this.isLastPositionOfGrabbedTemplateInsideSortableContent) {
        this.template.templates = this.filterTemplate(templatesBeforeSort)
        return
      }

      // Do not proceed sorting if CTRL is pressed, instead copy the template into its own set
      if (this.isCtrlKeyPressed) {
        this.handleCopyTemplateInSet(templatesBeforeSort[previousIndexInList])
        this.template = this.filterTemplate(templatesBeforeSort)
        return
      }

      if (!this.hoveredTemplate) {
        this.template.templates = this.filterTemplate(templatesBeforeSort)
        return
      }

      // Get new position from the sort event
      const droppedTemplate = this.$utils.clone(templatesBeforeSort[previousIndexInList])
      let newIndex = sortEvtVal.newIndex
      if (newIndex < 0) newIndex = 0
      this.hoveredTemplate = null

      // Remove template from list and insert into it's new position
      const templates = this.$utils.clone(templatesBeforeSort).filter((t) => { return t.templateId !== droppedTemplate.templateId })
      templates.splice(newIndex, 0, droppedTemplate)

      // Calculate order value
      const targetTemplate = templates[newIndex]
      const topSiblingDetails = (templates[newIndex - 1]) ? templates[newIndex - 1] : false
      const bottomSiblingDetails = (templates[newIndex + 1]) ? templates[newIndex + 1] : false
      const topSiblingOrder = topSiblingDetails ? topSiblingDetails.order : false
      const bottomSiblingOrder = bottomSiblingDetails ? bottomSiblingDetails.order : false
      const calcNewOrder = this.$utils.calculateSortOrderValue({ topSiblingOrder, bottomSiblingOrder, previousOrderVal, templateInSets: true })
      const template = this.$utils.clone(this.template)

      targetTemplate.order = calcNewOrder
      templates[newIndex] = targetTemplate
      template.templates = templates
      this.template = this.filterTemplate(template)

      // Do not proceed if index did not changed
      if (newIndex === previousIndexInList) {
        this.template.templates = this.filterTemplate(templatesBeforeSort)

        // Trigger onClick if small movement
        const maxPixelMovement = 10
        if (this.templateCardTargetBeforeSortPosition && this.templateCardTargetAfterSortPosition) {
          const beforeSortXPosition = this.templateCardTargetBeforeSortPosition.left
          const beforeSortYPosition = this.templateCardTargetBeforeSortPosition.top
          const afterSortXPosition = this.templateCardTargetAfterSortPosition.left
          const afterSortYPosition = this.templateCardTargetAfterSortPosition.top

          let xDifference = beforeSortXPosition - afterSortXPosition
          let yDifference = beforeSortYPosition - afterSortYPosition

          if (afterSortXPosition > beforeSortXPosition) {
            xDifference = afterSortXPosition - beforeSortXPosition
          }

          if (afterSortYPosition > beforeSortYPosition) {
            yDifference = afterSortYPosition - beforeSortYPosition
          }

          if (xDifference <= maxPixelMovement || yDifference <= maxPixelMovement) {
            this.handleTemplateCardClick(templatesBeforeSort[previousIndexInList])
          }
        }

        return
      }

      this.$utils.mainLoader(true)
      const apiRequest = () => {
        this.$api.put(`${CONFIG.API_BASE_URL}/template/${this.template.templateSetId}/${targetTemplate.templateId}`, { order: calcNewOrder })
          .then(response => {
            this.getTemplates(this.template.templateSetId, true)
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    watchTemplateCardGrabbing () {
      const setTargetTemplateSetIdAndHover = (e, setId) => {
        let templateDragToStyleSetIdOnOver = setId || null

        if (!setId) {
          const targetEl = e.target.parentElement
          const getStyleIdInClass = targetEl.className.toString().match(/(\bstyleId\S+\b)/ig)
          templateDragToStyleSetIdOnOver = getStyleIdInClass.length ? getStyleIdInClass[0].substr(7) : null
        }

        this.updateStyleDroppableEl({ removeOverClass: true })
        $(`.styleId${templateDragToStyleSetIdOnOver}`).addClass('drag-over')
        this.templateDragToStyleSetIdOnOver = templateDragToStyleSetIdOnOver
      }
      const thisComponent = this

      // Target element on mouse move
      $(document).on('mousemove', (e) => {
        if (thisComponent.isTemplateGrabbing) {
          const mousePageX = e.originalEvent.pageX
          const mousePageY = e.originalEvent.pageY

          // Check if grab position is inside sortable container
          const templateSetsPageSortWrapperEl = $('#templateSetsPageSortWrapper')
          const sortContainerStartX = templateSetsPageSortWrapperEl.offset().left
          const sortContainerEndX = sortContainerStartX + templateSetsPageSortWrapperEl.width()
          const sortContainerStartY = templateSetsPageSortWrapperEl.offset().top
          const sortContainerEndY = sortContainerStartY + templateSetsPageSortWrapperEl.height()

          if ((mousePageX >= sortContainerStartX && mousePageX <= sortContainerEndX) && (mousePageY >= sortContainerStartY && mousePageY <= sortContainerEndY)) {
            thisComponent.isLastPositionOfGrabbedTemplateInsideSortableContent = true
          } else {
            thisComponent.isLastPositionOfGrabbedTemplateInsideSortableContent = false
          }

          // Check if grab position inside style-set-drappable element
          if (e.target && $(e.target).hasClass('style-set-droppable')) {
            setTargetTemplateSetIdAndHover(e)
          } else {
            /**
             * Fallback if element.target is not supported by the browser like firefox
             * - Get the position of each droppable style element
             * - Get the mouse position and find match in positions lists
             */
            const targetStyleSetCoordinates = []

            $('.style-set-droppable').each((indx, el) => {
              const targetEl = el.parentElement
              const getStyleIdInClass = targetEl.className.toString().match(/(\bstyleId\S+\b)/ig)
              const elOffset = $(el).offset()

              targetStyleSetCoordinates.push({
                startX: elOffset.left,
                startY: elOffset.top,
                endX: elOffset.left + $(el).width(),
                endY: elOffset.top + $(el).height(),
                styleId: getStyleIdInClass.length ? getStyleIdInClass[0].substr(7) : null
              })
            })

            let targetStyleSetId = null
            for (const indx in targetStyleSetCoordinates) {
              const item = targetStyleSetCoordinates[indx]
              if ((mousePageX >= item.startX && mousePageX <= item.endX) && (mousePageY >= item.startY && mousePageY <= item.endY)) {
                targetStyleSetId = item.styleId
                break
              }
            }

            if (targetStyleSetId) {
              setTargetTemplateSetIdAndHover({}, targetStyleSetId)
            } else {
              thisComponent.templateDragToStyleSetIdOnOver = null
            }
          }

          // Watch cloned template card position
          const clonedCardEl = $('.sortable-fallback-template-card-cloned')
          if (clonedCardEl) {
            this.templateCardTargetAfterSortPosition = clonedCardEl.offset()
          }
        }
      })
    },
    updateStyleDroppableEl (evt) {
      $('.template-set-title').each((i, e) => {
        if (evt.removeOverClass) {
          $(e).removeClass('drag-over')
        } else if (evt.show) {
          $(e).addClass('show-draggable-cover')
        } else if (evt.reset) {
          $(e).removeClass('show-draggable-cover')
          $(e).removeClass('drag-over')
        }
      })
    },
    handleWindowClicked () {
      $(window).on('click', (e) => {
        const targetEl = e.target ? $(e.target) : null
        const isWhiteBackgroundClicked = targetEl && targetEl.hasClass('workspace')

        // Focus copy/paste textarea data wrapper
        const clipboardCopyPasteTextareaEl = $(`#${CLIPBOARD_COPY_PASTE_TEXTAREA_ID}`)
        const copiedTemplate = clipboardCopyPasteTextareaEl.length && clipboardCopyPasteTextareaEl.val().length > 0

        if (isWhiteBackgroundClicked && copiedTemplate) {
          clipboardCopyPasteTextareaEl.focus()
        }

        // Auto save Template Name
        if (isWhiteBackgroundClicked && this.inlineEditName.isInputVisible) {
          this.handleInlineEditNameInputConfirm(this.inlineEditName, 'onBlur')
        }
      })
    },
    onEnter (event) {
      if (event.target.id === 'template-item-name-input') {
        event.target.blur()
      }
    }
  },
  beforeMount () {
    this.removeUnsavedDataFlagInLocalStorage()
  },
  beforeUnmount () {
    this.removeMessageListener()

    if (document.getElementById(CLIPBOARD_COPY_PASTE_TEXTAREA_ID)) {
      document.body.removeChild(document.getElementById(CLIPBOARD_COPY_PASTE_TEXTAREA_ID))
    }
  },
  mounted () {
    this.addMessageListener()
    // Fetch templates on scroll
    this.$utils.infiniteScroll('templateListContainer', () => {
      if (this.template.moreItems && (this.template.exclusiveStartTemplateId && this.template.exclusiveStartGroupId)) {
        this.getTemplates(this.templateSetsSelected.templateSetId,
          false,
          {
            exclusiveStartTemplateId: this.template.exclusiveStartTemplateId,
            exclusiveStartGroupId: this.template.exclusiveStartGroupId
          },
          'getMoreItems'
        )
      }
    })
    this.setDefaultData()
    this.setCtrlKeyPressed()
    this.setShiftKeyPressed()
    this.handleWindowClicked()
  }
}
